import React from 'react';

const Button = ({ type, onClick, children }) => {
    return (
        <button type={type} onClick={onClick} className="px-6 py-2 mt-4 text-white bg-blue-600 rounded-lg hover:bg-blue-900">
            {children}
        </button>
    );
};

export default Button;
